import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InfoIcon from './../../../../../Assets/icons/InfoIcon.svg'
import './DetailsTable.scss'
import axiosInstance from '../../../../services/api/API';

const DetailsTable = ({
  headers,
  data,
  keyMapping,
  currentPage,
  handleViewButton = () => {},
  handleClicableRow = () => {},
  handleEditClick,
  handleQuantityChange,
  handleSave,
  editRowId,
  editedQuantity,
  updateIcon
}) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [dialogPosition, setDialogPosition] = useState({ top: 0, left: 0 });
  const [productInfo, setProductInfo] = useState([]);
  const token = localStorage.getItem("authToken");
useEffect(()=>{
  fetchPOInfoDetails();
},[])
  const fetchPOInfoDetails = async (rowData) => {
    console.log("rowdata===",rowData);
    
    try {
      const response = await axiosInstance.post(
        "/logistic/logisticinfo",
        {
          business_partner_id: rowData?.business_partner_id,
          showroom_id: rowData?.showroom_id,
          variant_id: rowData?.variant_id,
          itemtype: rowData?.itemtype,
          item_id: rowData?.item_id,
          vendor_id:rowData?.vendor_onboard_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.countdetail[0];
      setProductInfo(formattedData);
      console.log(formattedData, "Fetched PO Info Details");
    } catch (error) {
      console.error("Error fetching PO info details:", error);
    }
  };

  const handleInfoHover = async (row, event) => {
    // Get position of the info icon
    const iconRect = event.target.getBoundingClientRect();
    // Position the dialog above the icon
    setDialogPosition({
      top: iconRect.top + window.scrollY - 140, // Adjust this value to position the tooltip above
      left: iconRect.left + window.scrollX - 0, // Adjust for horizontal centering
    });
    setDialogData(row);
    setDialogOpen(true);
    
    // Fetch PO info details for the hovered row
    await fetchPOInfoDetails(row);
  };

  const handleInfoLeave = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <div className="logisticstable-container">
        <table className="custom-table">
          <thead>
            <tr>
              {headers?.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((row, rowIndex) => (
              <tr key={row.po_details_id} onClick={() => handleClicableRow(row)}>
                {headers?.map((header, colIndex) => {
                  const key = keyMapping[header];
                  if (header === 'Action') {
                    return (
                      <td key={colIndex}>
                        {key.map((action, actionIndex) => (
                          <img
                            key={actionIndex}
                            src={
                              row.po_details_id === editRowId && action.type === 'edit'
                                ? updateIcon 
                                : action.icon
                            }
                            style={{ gap: 5, marginLeft: 10 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              
                              if (action.type === 'edit' && row.po_details_id !== editRowId) {
                                handleEditClick(row); // Enter edit mode for this row
                              } else if (updateIcon) {
                                handleSave(row); // Save changes for this row
                              } else if (action.type === 'view') {
                                handleViewButton(row);
                              }
                            }}
                            className="action-icon"
                          />
                        ))}
                      </td>
                    );
                  }
// Render input field with info icon for both edit and non-edit modes
if (header === 'Quantity Approved') {
  return (
    <td key={colIndex} style={{ display: 'flex', alignItems: 'center' }}>
      {row.po_details_id === editRowId ? (
        <input
          type="number"
          value={editedQuantity[row.po_details_id] || ''}
          onChange={(e) => handleQuantityChange(e, row.po_details_id)}
          style={{
            width: '56px',
            height: '28px',
            padding: '4px',
            fontSize: '14px',
            fontWeight: '500',
            borderRadius: '4px',
            border: '2px solid #7BD755',
            paddingLeft: '10px',
            marginRight: '8px', // Spacing before the info icon
          }}
        />
      ) : (
        <span>{row[key]}</span> // Show quantity value when not editing
      )}
      <div className="info-icon"  onMouseEnter={(event) => handleInfoHover(row, event)}>
        <img
          src={InfoIcon}
          alt="Info"
          onMouseEnter={(event) => handleInfoHover(row, event)} // Show dialog on hover
          onMouseLeave={handleInfoLeave} // Hide dialog when mouse leaves
          style={{ width: '20px', height: '20px', marginLeft: '8px',marginBottom:'4px' }}
        />
      </div>
    </td>
  );
}

                  // Render input field with info icon only for the specific row in edit mode
                  // if (header === 'Quantity Approved' && row.po_details_id === editRowId) {
                  //   return (
                  //     <td key={colIndex} style={{ display: 'flex', alignItems: 'center' }}>
                  //       <input
                  //         type="number"
                  //         value={editedQuantity[row.po_details_id] || ''}
                  //         onChange={(e) => handleQuantityChange(e, row.po_details_id)}
                  //         style={{
                  //           width: '56px',
                  //           height: '28px',
                  //           padding: '4px',
                  //           fontSize: '14px',
                  //           fontWeight: '500',
                  //           borderRadius: '4px',
                  //           border: '2px solid #7BD755',
                  //           paddingLeft: '10px',
                  //           marginRight: '8px', // Spacing before the info icon
                  //         }}
                  //       />
                  //       <div className="info-icon">
                  //       <img
                  //         src={InfoIcon}
                  //         alt="Info"
                  //         onMouseEnter={(event) => handleInfoHover(row, event)} // Show dialog on hover
                  //         onMouseLeave={handleInfoLeave} // Hide dialog when mouse leaves
                  //         style={{  width: '20px', height: '20px' }}
                  //       />
                  //       </div>

                  //     </td>
                  //   );
                  // }
                 
                  return <td key={colIndex}>{row[key]}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Dialog box for additional information */}
      {isDialogOpen && (
        <div
          className="dialog-box"
          style={{
            position: 'absolute',
            top: `${dialogPosition.top}px`,
            left: `${dialogPosition.left}px`,
            backgroundColor: 'white',
            padding: '10px',
            border: '1px solid #ddd',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
          }}
        >
          <h5 className="infotitle mb-2">Stock Details</h5>
          <hr />
          <div className="stockinfo">
    
          <p>Available Quantity: <strong>{Number(productInfo?.good_qty)-Number(productInfo?.selected_postockinsr_count)}</strong></p>
          <p>Requested Quantity: <strong>{Number(productInfo?.pending_qty)}</strong></p>
        </div>
          
        </div>
      )}
    </>
  );
};

DetailsTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  keyMapping: PropTypes.object.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleQuantityChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  editRowId: PropTypes.number,
  editedQuantity: PropTypes.object.isRequired,
};

DetailsTable.defaultProps = {
  itemsPerPage: 10,
  isAllocation: false,
};

export default DetailsTable;
